import UserEditFilters, {
    UserEditFilterNames,
    UserEditFormSection,
    userEditFilterDefaults
} from "root/s360components/UserRename/UserEditFilters";
import {useForm} from "react-hook-form";
import UserEditManager from "root/s360components/UserRename/UserEditManager";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";

const UserEditContainer = ({}) =>
{
    const {control, getValues, resetField} = useForm({
        defaultValues: {
            ...userEditFilterDefaults()
        }
    });

    const [ encSchoolId ] = useWatchDropdown( {control, name: UserEditFormSection + '.' + UserEditFilterNames.SCHOOL, namedField: 'enc_school_id', isInt: false} ) ;
    const [ userType ] = useWatchDropdown( {control, name: UserEditFormSection + '.' + UserEditFilterNames.USER_TYPE} ) ;

    return (
        <div className='sims-admin-container'>
            <h2>User Edit Tool</h2>
            <p key='this-screen'>This screen allows admins to safely edit details for users by school and role.</p>
            <p key='All-users' style={{color: '#b77171'}}>All users can be accessed here</p>
            <label>Please select an LEA, school and user role</label>
            <UserEditFilters control={control} resetField={resetField} getValues={getValues}
                             sectionName={UserEditFormSection} key='UEF'/>
            <UserEditManager encSchoolId={encSchoolId} userType={userType} key='UEM'/>
        </div>
    )
}

export default UserEditContainer;
